import { getMessages } from '../../../../../../store/constants';

export const getSharedDrivesScopesBlockerText = () => getMessages().getText('open_boards.blocker.permissions.sharedDrives.text');
export const SHARED_DRIVES_SCOPES_BLOCKER_LINK = '/dashboard/microsoft-groups-permission?microsoft=true';
export const SHARED_DRIVES_SCOPES_BLOCKER_COPY = getMessages().getText('common.copy_link');
export const SHARED_DRIVES_SCOPES_BLOCKER_COPIED = getMessages().getText('common.copied');
